export function root(bid: string): string {
	return `/brands/${bid}`
}

export function metrics_approvals(bid: string): string {
	return `${root(bid)}/metrics/approvals`
}

export function metrics_training(bid: string): string {
	return `${root(bid)}/metrics/training`
}

export function metrics_asset_types(bid: string): string {
	return `${root(bid)}/metrics/asset-types`
}

export function metrics_score_failures(bid: string): string {
	return `${root(bid)}/metrics/score-failures`
}

export function metrics_model_accuracy(bid: string): string {
	return `${root(bid)}/metrics/model-accuracy`
}

export function metrics_feedback_trends(bid: string): string {
	return `${root(bid)}/metrics/feedback-trends`
}
